// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10R3t","productName":"Table_productName__p2Lqy"};